import { ReactNode, useReducer } from 'react';
import TradeContext from './tradeContext';
import TradeReducer from './tradeReducer';
import { ExchangeTradeTypes, TradeStateType } from './tradeTypes';

type TradeStateProps = {
    children: ReactNode;
};

const initialState: TradeStateType = {
    isShort: false,
    tradeType: ExchangeTradeTypes.MARKET,
    leverage: '3',
    collateral: '',
    limitPrice: '',
};

const TradeState: React.FC<TradeStateProps> = ({ children }) => {
    const [state, dispatch] = useReducer(TradeReducer, initialState);

    return (
        <TradeContext.Provider value={{ ...state, dispatch }}>
            {children}
        </TradeContext.Provider>
    );
};

export default TradeState;
